import { useQuery } from '@tanstack/react-query';
import { API_PATHS, API_CACHE_KEYS } from '@/modules/common/constants';

export type FeeStructurePdfPayload = {
  html: string;
  style: string;
};

export const useDownloadFeeStructure = () =>
  useQuery({
    queryKey: [API_CACHE_KEYS.DOWNLOAD_FEE_STRUCTURE],
    queryFn: async (): Promise<FeeStructurePdfPayload> => {
      const token = localStorage.getItem('TOKEN');
      const response = await fetch(
        `${process.env.NEXT_PUBLIC_BASE_API_URL}${API_PATHS.DOWNLOAD_FEE_STRUCTURE}`,
        {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error('Fee structure file is not available');
      }

      const json = await response.json();
      const html = json?.data?.html;
      if (!html) {
        throw new Error('Fee structure file is not available');
      }

      return { html, style: json?.data?.style ?? '' };
    },
    enabled: false,
  });
